// @flow
import JQueryView, { on } from '../../common/JQueryView';

declare var $: any;

export default class ShowView extends JQueryView {
  constructor() {
    super('#fundraising_sim');
  }

  @on('click #scroll-button')
  onClickScrollButton() {
    const offset = $('#simulator').offset()?.top;

    if (offset !== undefined) {
      $('html, body').animate({ scrollTop: offset }, 600);
    }
  }
}
